import { gql, useMutation } from '@apollo/client'
import type { GQL_ID } from '@@partner:types:graphql'

export interface DeleteCityMutation {
  deleteCity: boolean
}

export interface DeleteCityVariables {
  id: GQL_ID
}

export const GQL_MUTATION_DELETE_CITY = gql`
  mutation deleteCity($id: ID!) {
    deleteCity(id: $id)
  }
`

export const useDeleteCity = () =>
  useMutation<DeleteCityMutation, DeleteCityVariables>(GQL_MUTATION_DELETE_CITY)
